export const documentLoaded = () => ( {
    type: 'DOCUMENT_LOADED',
} );
